/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Videos_Status_ProcessingInputs */

const en_settings_videos_status_processing = /** @type {(inputs: Settings_Videos_Status_ProcessingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transferring the performance…`)
};

/**
* | output |
* | --- |
* | "Transferring the performance…" |
*
* @param {Settings_Videos_Status_ProcessingInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_videos_status_processing = /** @type {((inputs?: Settings_Videos_Status_ProcessingInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Videos_Status_ProcessingInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_videos_status_processing(inputs)
});
export { settings_videos_status_processing as "settings.videos.status_processing" }